import {
    StyleSheet
} from "react-native";
import {
    webStyle
} from "ncore-ui-kit";

const stylesheet = StyleSheet.create({
    actionContainer: {
        justifyContent: "flex-end",
        flexDirection: "row"
    },
    photoButtonsContainer: {
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center"
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center",
        minHeight: 300
    },
    photoUploadBox: {
        justifyContent: "center",
        borderStyle: "dashed",
        alignItems: "center",
        aspectRatio: 3 / 4,
        overflow: "hidden",
        borderWidth: 1,
        width: 160,
        ...webStyle({
            cursor: "pointer"
        })
    },
    photoPlaceholderContent: {
        alignItems: "center"
    },
    editorHeader: {
        flexDirection: "row",
        alignItems: "center"
    },
    photoContainer: {
        alignItems: "center"
    },
    formCard: {
        overflow: "hidden",
        width: "100%"
    },
    contentWrapper: {
        borderWidth: 1,
        width: "100%"
    },
    photoPreview: {
        height: "100%",
        width: "100%"
    },
    photoInput: {
        display: "none"
    },
    editorSection: {
        width: "100%"
    },
    formContainer: {
        width: "100%"
    },
    container: {
        width: "100%"
    }
});
export default stylesheet;
